import { render, staticRenderFns } from "./CancleBooking.vue?vue&type=template&id=60854f72&scoped=true"
import script from "./CancleBooking.vue?vue&type=script&lang=js"
export * from "./CancleBooking.vue?vue&type=script&lang=js"
import style0 from "./CancleBooking.vue?vue&type=style&index=0&id=60854f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60854f72",
  null
  
)

export default component.exports